import { ITermSession, ISection } from '../../../interfaces/scheduler_interfaces';
import { Datasource, IDatasource, Metasource } from 'utility-ng-kernel';
import { TermSession } from '../builders/term_session_builder';
import { key } from 'core-ts-types';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import * as _4 from 'lodash4';

export interface ITermSessionsDatasource extends IDatasource<ITermSession> {}

angular.module('capability-ng-scheduler').factory(
  'ngTermSessionsDatasource',
  (): ITermSessionsDatasource =>
    new Datasource<ITermSession>({
      builderType: TermSession
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/datasources/term_sessions_datasource.ts